import styled from 'styled-components';

export default styled.h3`
  margin: 10px 0;
  font-weight: 600;
`;
